// extracted by mini-css-extract-plugin
export default {"dropdown":"ShareButton_dropdown__5u+Qy"};